export default __webpack_public_path__ + "static/media/antelope-6-thumbnail.59d2964e.webp";